import type {Address} from './Address';
import type {SelfEmployedInformation} from './SelfEmployedInformation';

export type ContactInformation = {
  registrationNumber: string;
  vatNumber: string;
  companyName: string;
  fileNumber: string | null;
  address: Address | null;
  selfEmployedInformation: SelfEmployedInformation | null;
};
